import React from 'react';
import Type from 'prop-types';
import { Route, Router } from 'react-router-dom';

import App from '../../containers/App';
import Header from '../Common/Header';
import NotFoundPage from '../NotFound';
import {Box, Button, Container} from "@mui/material";
import {keycloak} from "../../keycloak-config";

//import BelkaShopping from "../../img/belka_shopping.png"
import BelkaShopping from "../../img/belka2x.png"


class Site extends React.Component {

    static propTypes = {
    };

    state = {
    };

    render() {
        return (
            <Container sx={{pt:5, mb:5, pb:0}}>
                <Box className="page-main-box belka-login-bg"
                     sx={{mb:5, display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between'}}>
                    <img src={BelkaShopping}  onClick={keycloak.login} />
                </Box>
            </Container>
        );
    }
}

export default Site;
